<!--  推荐菜 商家介绍下面是用 -->
<template>
<div class="dish-min" v-if="dishList.length>0">
    <div class="dish-head">
        <div class="title">推荐菜</div>
        <el-button plain icon="el-icon-plus" size="mini" @click="addSuggestDishStatus=true">添加</el-button>
    </div>
    <div class="filter">
        <div class="item" :class="{active:dishParams.typeIdList.length == 0}" @click="filterChange(0)">全部</div>
        <div class="item" v-for="item in dishClassList" :key="item.id" :class="{active:dishParams.typeIdList.includes(item.id)}" @click="filterChange(item.id)">{{ item.name }}</div>
        <div class="flex-cont"></div>
        <span class="look-more" @click="$emit('lookMore')">查看更多 &gt;</span>
    </div>
    <div class="info-list">
        <div class="item" v-for="item in dishList" :key="item.id">
            
            <RecommendDishItem  :dish="item" />
        </div>
    </div>
    <AddSuggestDishDialog :status.sync="addSuggestDishStatus" :info="post" />
</div>
</template>
<script>
import AddSuggestDishDialog from './add-suggest-dish-dialog.vue'
import RecommendDishItem from './recommend-dish-item.vue'
export default {
    name:'RecommendDishMin',
    props:['post'],
    components:{
        AddSuggestDishDialog,
        RecommendDishItem,
    },
    data(){
        return {
            addSuggestDishStatus:false,
            dishClassList:[],
            dishList:[],
            dishParams:{
                "postId": "",
                "typeIdList": [],
                "offset": 1,
                "size": 10
            }
        }
    },
    created(){
        this.dishParams.postId = this.post.id;
        this.getClass();
        this.getList();
    },
    methods:{
        filterChange(id){
            if( id == 0 ){
                this.dishParams.typeIdList = [];
            }else{
                this.dishParams.typeIdList = [id]
            }
            this.getList();
        },
        async getClass(){
            let result = await this.$axios.post('/comment/frontend/v1/get/dish/type/list/of/post',{postId:this.post.id})
            
            if( result.code == 0 ){
                this.dishClassList = result.data.types;
            }
        },
        async getList(){
            let result = await this.$axios.post('/comment/frontend/v1/get/dish/list/of/post',this.dishParams);
            
            if( result.code == 0 ){
                this.dishList = result.data.dishList.splice(0,5);
                
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.dish-min{
    margin-top: 20px; 
    .dish-head{
        display: flex; justify-content: space-between; margin-bottom: 10px;
        .title{font-size: 20px; line-height: 30px; font-weight: bold;}
    }
    .filter{
        display: flex;  align-items: center;
        .flex-cont{flex:1; overflow: hidden;}
        .item{
            font-size: 14px; line-height: 30px; padding: 0 10px; border: 1px solid #dcdfe6; color: #606266; border-radius: 4px; margin-right: 10px;
            user-select: none; cursor: pointer;
            &:hover{
                background: #fef0f0; color: #f56c6c; border-color: #fbc4c4;
            }
            &.active{
                background: #fef0f0; color: #f56c6c; border-color: #fbc4c4;
            }
        }
        .look-more{font-size: 14px; color: #666; user-select: none; cursor: pointer;
            &:hover{color: #e43a3a;}
        }
    }
    .info-list{
        display: flex; margin: 20px -10px 0;
        .item{
            width:20%; padding: 0 10px; box-sizing: border-box;
            
        }
    }
}
</style>